'use strict';

var encode = require('./base62-encode');
var hash = require('./hash-string');

module.exports = function fileScoper(fileSrc) {
  var suffix = encode(hash(fileSrc));

  return function scopedName(name) {
    return name + '_' + suffix;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/csjs/lib/scoped-name.js
 ** module id = 19
 ** module chunks = 0
 **/